// import React, { useEffect, useState } from "react";
// import moment from "moment";
// import { Clock, Pencil, Plus, Trash2 } from "lucide-react";
// import { showToastNotification } from "../../utility/helper";
// import MainHeading from "../../components/common/MainHeading";
// import CommonFilter, {
//   type IFilter,
// } from "../../components/common/CommonFilter";
// import TablePagination from "../../components/common/TablePagination";
// import type { IPageInfo } from "@/interface/common.interface";
// import type { TableColumn } from "@/components/common/CommonTable";
// import CommonTable from "@/components/common/CommonTable";
// import AddShiftModal from "./AddShiftModal";
// import { ThrowError } from "../../api/callApi";
// import { ShiftService } from "@/services/Shift/Shift";
// import type { IShift } from "@/interface/shift.interface";
// import CommonModal from "@/components/common/CommonModal";
// import RowActionsMenu from "@/components/common/RowActionsMenu";

// const STATUS_OPTIONS = [
//   { label: "All", value: "" },
//   { label: "Active", value: "active" },
//   { label: "Inactive", value: "inactive" },
// ];

// const getTotalHours = (start: string, end: string) => {
//   if (!start || !end) return 0;
//   const [sh, sm] = start.split(":").map(Number);
//   const [eh, em] = end.split(":").map(Number);
//   let minutes = eh * 60 + em - (sh * 60 + sm);
//   if (minutes < 0) minutes += 24 * 60;
//   return parseFloat((minutes / 60).toFixed(1));
// };

// // Shift names are free text ("Day", "Night", "Afternoon", "Half Day", "First Half"...),
// // so the accent color is derived from the shift's own id rather than hardcoded per name.
// // Same shift always gets the same color; any new name still renders a readable badge.
// // NOTE: this is duplicated from the Labor list page — worth moving to a shared
// // utils file (e.g. src/utility/shiftColor.ts) so both stay in sync.
// const SHIFT_VARIANTS = [
//   { bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-500" },
//   { bg: "bg-indigo-50", text: "text-indigo-700", dot: "bg-indigo-500" },
//   { bg: "bg-orange-50", text: "text-orange-700", dot: "bg-orange-500" },
//   { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500" },
//   { bg: "bg-sky-50", text: "text-sky-700", dot: "bg-sky-500" },
// ];

// const getShiftVariant = (key: string) => {
//   let hash = 0;
//   for (let i = 0; i < key.length; i++) {
//     hash = (hash << 5) - hash + key.charCodeAt(i);
//     hash |= 0;
//   }
//   return SHIFT_VARIANTS[Math.abs(hash) % SHIFT_VARIANTS.length];
// };

// export const Shift: React.FC = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [shiftList, setShiftList] = useState<IShift[]>([]);
//   const [showModal, setShowModal] = useState(false);
//   const [editingShift, setEditingShift] = useState<IShift | null>(null);
//   const [deleteModalOpen, setDeleteModalOpen] = useState(false);
//   const [shiftToDelete, setShiftToDelete] = useState<string | null>(null);

//   const [filter, setFilter] = useState<IFilter>({
//     search: "",
//     status: "",
//   });

//   const [paginationData, setPaginationData] = useState<IPageInfo>({
//     currentPage: 1,
//     pageSize: 10,
//     total: 0,
//     totalPages: 0,
//   });

//   const fetchShifts = async (
//     page = paginationData.currentPage,
//     limit = paginationData.pageSize,
//   ) => {
//     setIsLoading(true);
//     try {
//       const response = await ShiftService.getShiftList({
//         pageIndex: page,
//         pageSize: limit,
//         search: filter.search || undefined,
//         status: filter.status || undefined,
//         sort: "createdAt",
//         order: "DESC",
//       });

//       if (response?.success) {
//         setShiftList(response.data.rows || []);
//         setPaginationData({
//           currentPage: response.data.pageIndex,
//           pageSize: response.data.pageSize,
//           total: response.data.total,
//           totalPages: response.data.totalPages,
//         });
//       }
//     } catch (error) {
//       ThrowError(error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchShifts(paginationData.currentPage, paginationData.pageSize);
//   }, [paginationData.currentPage, paginationData.pageSize, filter]);

//   const handleSearchChange = (value: string) => {
//     setFilter((prev) => ({ ...prev, search: value }));
//     setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleFilterChange = (value: string, name: string) => {
//     setFilter((prev) => ({ ...prev, [name]: value }));
//     setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleChangePageSize = (value: number) => {
//     setPaginationData((prev) => ({ ...prev, pageSize: value, currentPage: 1 }));
//   };

//   const openAddModal = () => {
//     setEditingShift(null);
//     setShowModal(true);
//   };

//   const openEditModal = (shift: IShift) => {
//     setEditingShift(shift);
//     setShowModal(true);
//   };

//   const handleModalClose = () => {
//     setShowModal(false);
//     setEditingShift(null);
//   };

//   const handleModalSuccess = () => {
//     fetchShifts(paginationData.currentPage, paginationData.pageSize);
//   };

//   const openDeleteModal = (id: string) => {
//     setShiftToDelete(id);
//     setDeleteModalOpen(true);
//   };

//   const confirmDelete = async () => {
//     if (!shiftToDelete) return;
//     try {
//       const response = await ShiftService.deleteShift(shiftToDelete);
//       if (response?.success) {
//         showToastNotification("success", response.message || "Shift deleted");
//         fetchShifts(paginationData.currentPage, paginationData.pageSize);
//       } else {
//         showToastNotification(
//           "danger",
//           response?.message || "Failed to delete shift",
//         );
//       }
//     } catch (error) {
//       ThrowError(error);
//     } finally {
//       setDeleteModalOpen(false);
//       setShiftToDelete(null);
//     }
//   };

//   const cancelDelete = () => {
//     setDeleteModalOpen(false);
//     setShiftToDelete(null);
//   };

//   const columns: TableColumn<IShift>[] = [
//     {
//       key: "sNo",
//       header: "S.No",
//       render: (_item, index) => (
//         <span className="text-muted-foreground font-medium text-sm">
//           {(paginationData.currentPage - 1) * paginationData.pageSize +
//             index +
//             1}
//         </span>
//       ),
//     },
//     {
//       key: "shiftName",
//       header: "Shift Name",
//       render: (item) => {
//         const variant = getShiftVariant(item.id || item.shiftName);
//         return (
//           <div className="flex items-center gap-3">
//             <div
//               className={`h-9 w-9 rounded-full flex items-center justify-center shrink-0 ${variant.bg} ${variant.text}`}
//             >
//               <Clock className="h-4 w-4" />
//             </div>
//             <span className="font-semibold text-gray-700">{item.shiftName}</span>
//           </div>
//         );
//       },
//     },
//     {
//       key: "timing",
//       header: "Timing",
//       render: (item) => (
//         <span className="text-gray-600">
//           {moment(item.startTime, "HH:mm").format("hh:mm A")} –{" "}
//           {moment(item.endTime, "HH:mm").format("hh:mm A")}
//         </span>
//       ),
//     },
//     {
//       key: "totalHours",
//       header: "Total Hours",
//       render: (item) => (
//         <span className="font-medium">
//           {getTotalHours(item.startTime, item.endTime)} hrs
//         </span>
//       ),
//     },
//     {
//       key: "status",
//       header: "Status",
//       render: (item) => (
//         <span
//           className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide rounded-full ${
//             item.status === "active"
//               ? "text-green-600 bg-green-50"
//               : "text-red-600 bg-red-50"
//           }`}
//         >
//           <span
//             className={`h-1.5 w-1.5 rounded-full ${
//               item.status === "active" ? "bg-green-500" : "bg-red-500"
//             }`}
//           />
//           {item.status}
//         </span>
//       ),
//     },
//     {
//   key: "actions",
//   header: "Actions",
//   render: (item) => (
//     <RowActionsMenu
//       actions={[
//         {
//           label: "Edit",
//           icon: <Pencil className="h-4 w-4" />,
//           onClick: () => openEditModal(item),
//         },
//         {
//           label: "Delete",
//           icon: <Trash2 className="h-4 w-4" />,
//           onClick: () => openDeleteModal(item.id),
//           variant: "destructive",
//         },
//       ]}
//     />
//   ),
// }
//   ];

//   return (
//     <div>
//       <div className="space-y-6">
// <MainHeading
//   title="Shift Management"
//   buttonText="Add Shift"
//   buttonIcon={<Plus size={16} />}
//   onClick={openAddModal}
// />

//         <div className="bg-white border border-slate-200/70 rounded-xl shadow-sm p-4 sm:p-5 space-y-4">
//           <CommonFilter
//             searchValue={filter.search || ""}
//             onSearchChange={handleSearchChange}
//             value={filter}
//             filterOptions={STATUS_OPTIONS}
//             filterName="status"
//             filterPlaceholder="Select Status"
//             onChange={handleFilterChange}
//           />
//           <CommonTable
//             data={shiftList}
//             columns={columns}
//             loading={isLoading}
//             stickyColumns={2}
//           />
//           <TablePagination
//             paginationData={paginationData}
//             setPaginationData={setPaginationData}
//             handleChangePageSize={handleChangePageSize}
//             isLoading={isLoading}
//           />
//         </div>
//       </div>

//       <AddShiftModal
//         show={showModal}
//         onClose={handleModalClose}
//         onSuccess={handleModalSuccess}
//         editData={editingShift}
//       />

//       <CommonModal
//         title="Delete Shift"
//         show={deleteModalOpen}
//         onClose={cancelDelete}
//         className="max-w-sm"
//       >
//         <div className="flex flex-col items-center text-center">
//           <div className="h-12 w-12 rounded-full bg-red-50 text-red-600 flex items-center justify-center mb-4">
//             <Trash2 size={22} />
//           </div>
//           <h3 className="text-lg font-bold text-gray-900 mb-1.5">
//             Are you sure?
//           </h3>
//           <p className="text-sm text-gray-500 leading-relaxed mb-6">
//             This action cannot be undone. The shift will be permanently removed.
//           </p>
//           <div className="flex items-center gap-3 w-full">
//             <button
//               onClick={cancelDelete}
//               className="flex-1 rounded-xl h-11 border border-gray-200 hover:bg-gray-50 text-gray-700 font-medium"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={confirmDelete}
//               className="flex-1 rounded-xl h-11 bg-red-600 hover:bg-red-700 text-white font-medium flex items-center justify-center gap-2"
//             >
//               Yes, Delete
//             </button>
//           </div>
//         </div>
//       </CommonModal>
//     </div>
//   );
// };

// export default Shift;


import React, { useEffect, useState } from "react";
import moment from "moment";
import { Clock, Pencil, Plus, Trash2 } from "lucide-react";
import { showToastNotification } from "../../utility/helper";
import MainHeading from "../../components/common/MainHeading";
import CommonFilter, {
  type IFilter,
} from "../../components/common/CommonFilter";
import TablePagination from "../../components/common/TablePagination";
import type { IPageInfo } from "@/interface/common.interface";
import type { TableColumn } from "@/components/common/CommonTable";
import CommonTable from "@/components/common/CommonTable";
import AddShiftModal from "./AddShiftModal";
import { ThrowError } from "../../api/callApi";
import { ShiftService } from "@/services/Shift/Shift";
import type { IShift } from "@/interface/shift.interface";
import CommonModal from "@/components/common/CommonModal";
import RowActionsMenu from "@/components/common/RowActionsMenu";
import { StatusBadge, IconCell, getToneForKey } from "../../components/common/Badge";

const STATUS_OPTIONS = [
  { label: "All", value: "" },
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

const getTotalHours = (start: string, end: string) => {
  if (!start || !end) return 0;
  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);
  let minutes = eh * 60 + em - (sh * 60 + sm);
  if (minutes < 0) minutes += 24 * 60;
  return parseFloat((minutes / 60).toFixed(1));
};

export const Shift: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [shiftList, setShiftList] = useState<IShift[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [editingShift, setEditingShift] = useState<IShift | null>(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [shiftToDelete, setShiftToDelete] = useState<string | null>(null);

  const [filter, setFilter] = useState<IFilter>({
    search: "",
    status: "",
  });

  const [paginationData, setPaginationData] = useState<IPageInfo>({
    currentPage: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0,
  });

  const fetchShifts = async (
    page = paginationData.currentPage,
    limit = paginationData.pageSize,
  ) => {
    setIsLoading(true);
    try {
      const response = await ShiftService.getShiftList({
        pageIndex: page,
        pageSize: limit,
        search: filter.search || undefined,
        status: filter.status || undefined,
        sort: "createdAt",
        order: "DESC",
      });

      if (response?.success) {
        setShiftList(response.data.rows || []);
        setPaginationData({
          currentPage: response.data.pageIndex,
          pageSize: response.data.pageSize,
          total: response.data.total,
          totalPages: response.data.totalPages,
        });
      }
    } catch (error) {
      ThrowError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchShifts(paginationData.currentPage, paginationData.pageSize);
  }, [paginationData.currentPage, paginationData.pageSize, filter]);

  const handleSearchChange = (value: string) => {
    setFilter((prev) => ({ ...prev, search: value }));
    setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleFilterChange = (value: string, name: string) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
    setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleChangePageSize = (value: number) => {
    setPaginationData((prev) => ({ ...prev, pageSize: value, currentPage: 1 }));
  };

  const openAddModal = () => {
    setEditingShift(null);
    setShowModal(true);
  };

  const openEditModal = (shift: IShift) => {
    setEditingShift(shift);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setEditingShift(null);
  };

  const handleModalSuccess = () => {
    fetchShifts(paginationData.currentPage, paginationData.pageSize);
  };

  const openDeleteModal = (id: string) => {
    setShiftToDelete(id);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!shiftToDelete) return;
    try {
      const response = await ShiftService.deleteShift(shiftToDelete);
      if (response?.success) {
        showToastNotification("success", response.message || "Shift deleted");
        fetchShifts(paginationData.currentPage, paginationData.pageSize);
      } else {
        showToastNotification(
          "danger",
          response?.message || "Failed to delete shift",
        );
      }
    } catch (error) {
      ThrowError(error);
    } finally {
      setDeleteModalOpen(false);
      setShiftToDelete(null);
    }
  };

  const cancelDelete = () => {
    setDeleteModalOpen(false);
    setShiftToDelete(null);
  };

  // Columns — the shift-name icon box now uses IconCell with a color
  // derived from getToneForKey (shared with ShiftBadge's fallback logic
  // used on the Labor page), so a given shift gets the same accent color
  // everywhere it appears in the app, not just on this page.
  const columns: TableColumn<IShift>[] = [
    {
      key: "sNo",
      header: "S.No",
      render: (_item, index) => (
        <span className="text-muted-foreground font-medium text-sm">
          {(paginationData.currentPage - 1) * paginationData.pageSize +
            index +
            1}
        </span>
      ),
    },
    {
      key: "shiftName",
      header: "Shift Name",
      render: (item) => (
        <IconCell
          icon={<Clock className="h-4 w-4" />}
          title={item.shiftName}
          tone={getToneForKey(item.id || item.shiftName)}
        />
      ),
    },
    {
      key: "timing",
      header: "Timing",
      render: (item) => (
        <span className="text-gray-600">
          {moment(item.startTime, "HH:mm").format("hh:mm A")} –{" "}
          {moment(item.endTime, "HH:mm").format("hh:mm A")}
        </span>
      ),
    },
    {
      key: "totalHours",
      header: "Total Hours",
      render: (item) => (
        <span className="font-medium">
          {getTotalHours(item.startTime, item.endTime)} hrs
        </span>
      ),
    },
    {
      key: "status",
      header: "Status",
      render: (item) => (
        <StatusBadge status={item.status === "active" ? "Active" : "Inactive"} />
      ),
    },
    {
      key: "actions",
      header: "Actions",
      render: (item) => (
        <RowActionsMenu
          actions={[
            {
              label: "Edit",
              icon: <Pencil className="h-4 w-4" />,
              onClick: () => openEditModal(item),
            },
            {
              label: "Delete",
              icon: <Trash2 className="h-4 w-4" />,
              onClick: () => openDeleteModal(item.id),
              variant: "destructive",
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div>
      <div className="space-y-6">
        <MainHeading
          title="Shift Management"
          buttonText="Add Shift"
          buttonIcon={<Plus size={16} />}
          onClick={openAddModal}
        />

        <div className="bg-white border border-slate-200/70 rounded-xl shadow-sm p-4 sm:p-5 space-y-4">
          <CommonFilter
            searchValue={filter.search || ""}
            onSearchChange={handleSearchChange}
            value={filter}
            filterOptions={STATUS_OPTIONS}
            filterName="status"
            filterPlaceholder="Select Status"
            onChange={handleFilterChange}
          />
          <CommonTable
            data={shiftList}
            columns={columns}
            loading={isLoading}
            stickyColumns={2}
          />
          <TablePagination
            paginationData={paginationData}
            setPaginationData={setPaginationData}
            handleChangePageSize={handleChangePageSize}
            isLoading={isLoading}
          />
        </div>
      </div>

      <AddShiftModal
        show={showModal}
        onClose={handleModalClose}
        onSuccess={handleModalSuccess}
        editData={editingShift}
      />

      <CommonModal
        title="Delete Shift"
        show={deleteModalOpen}
        onClose={cancelDelete}
        className="max-w-sm"
      >
        <div className="flex flex-col items-center text-center">
          <div className="h-12 w-12 rounded-full bg-red-50 text-red-600 flex items-center justify-center mb-4">
            <Trash2 size={22} />
          </div>
          <h3 className="text-lg font-bold text-gray-900 mb-1.5">
            Are you sure?
          </h3>
          <p className="text-sm text-gray-500 leading-relaxed mb-6">
            This action cannot be undone. The shift will be permanently removed.
          </p>
          <div className="flex items-center gap-3 w-full">
            <button
              onClick={cancelDelete}
              className="flex-1 rounded-xl h-11 border border-gray-200 hover:bg-gray-50 text-gray-700 font-medium"
            >
              Cancel
            </button>
            <button
              onClick={confirmDelete}
              className="flex-1 rounded-xl h-11 bg-red-600 hover:bg-red-700 text-white font-medium flex items-center justify-center gap-2"
            >
              Yes, Delete
            </button>
          </div>
        </div>
      </CommonModal>
    </div>
  );
};

export default Shift;